var productCardMarkup = `
  <div class="swym-wishlist-grid collection-grid">
   {{#products}} 
     <div class="product-item swym-wishlist-item swym-is-anchorc col_slide">
        <div class="snippet-product-grid" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" data-variant-name="{{vi}}">
           <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
             <span class="swym-icon"><svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.24363 15.1638C3.09885 15.2072 1.75929 11.8856 1.57738 8.91801C1.3728 5.56943 2.58434 1.72042 3.88776 1.65611C4.1346 1.64386 4.32387 1.76942 4.42126 1.83374C5.68425 2.6741 4.47516 5.75195 5.64505 6.3761C5.75285 6.43367 5.84411 6.45082 5.86861 6.45511C7.27432 6.70257 8.40134 2.00034 10.0582 2.11304C10.3479 2.13264 10.5506 2.29189 10.6045 2.33477C12.7514 4.06082 5.85269 13.4904 4.96577 14.6621C4.83531 14.8342 4.58908 15.1509 4.24363 15.1638Z" fill="black" stroke="black" stroke-width="0.661111" stroke-miterlimit="10"/></svg></span>
           </button>
           <span class="swym-tooltip swym-inject swym-tooltip-clickable"><span class="swym-tooltip-text">Add to wishlist</span></span></button>
           <div class="grid-top">
              <div class="grid-imagebox">
                 <a href="{{du}}" class="product-link">
                    <div class="product-images">
                      <img alt="" class="swym-wishlist-image" src="{{iu}}">
                      <img alt="" class="second-image" src="">
                    </div>
                 </a>
              </div>
              <div class="grid-meta">
                 <div class="grid-meta-inr" bss-b2b-product-id="8736644104356" bss-b2b-product-parent-price="true" style="visibility: visible;">
                    <p class="grid-title">
                      <a href="{{du}}">{{dt}}</a> 
                      <span class="pro-sold" style="display:none">SOLD OUT</span>
                      <span class="s-body sale_badge" style="display:none">SALE</span>
                      <button class="custom-btn d-lg-none">+</button>
                    </p>
                    <p class="grid-price">
                      <span class="swym-product-final-price original-price" data-wpd-product-handle="" data-wpd-variant-id="{{epi}}" 
                      data-wpd-variant-price="" data-wpd-variant-compare-at-price="" data-wpd-product-id="{{empi}}">{{cu}}{{pr}}</span>
                      <span class="compare-price d-none" style="display:none">{{cu}}<span>&nbsp;</span></span>
                    </p>
                    <span class="pro-sold d-lg-none" style="display:none">SOLD OUT</span>
                 </div>
              </div>
           </div>
           <div class="grid-btm">
           <div class="cus-add-btn">
               <button class="button button-white button-full">Add to bag</button>
           </div>
           <div class="wm-btn">
             <div class="size_variant">
                   <div class="grid-variant-outer">
                      <div class="grid-error"></div>
                      <span>Choose a size:</span>
                      <div class="grid-size-wrapper">&nbsp;</div>
                   </div>
                </div>
                <div class="grid-variant-btns">
                   <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="button button-white button-full site-add-btn swym-add-to-cart-btn swym-is-button">
                     <span class="adding-cart">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none"><g clip-path="url(#clip0_1_36487)" filter="url(#filter0_b_1_36487)"><path d="M12.1875 6.09375V6.5C12.1875 9.64112 9.64112 12.1875 6.5 12.1875V12.1875C3.35888 12.1875 0.8125 9.64112 0.8125 6.5V6.5C0.8125 3.35888 3.35888 0.8125 6.5 0.8125V0.8125" stroke="currentColor" stroke-width="0.8125" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><filter id="filter0_b_1_36487" x="-60" y="-60" width="133" height="133" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feGaussianBlur in="BackgroundImageFix" stdDeviation="30"></feGaussianBlur><feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_36487"></feComposite><feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_36487" result="shape"></feBlend></filter><clipPath id="clip0_1_36487"><rect width="13" height="13" fill="white"></rect></clipPath></defs></svg>
                        <span>Adding to cart</span>
                     </span>
                     <span class="added-cart">
                       <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none"><g filter="url(#filter0_b_1_36281)"><path d="M0.8125 8.125L4.0625 10.9688L12.1875 1.625" stroke="currentColor" stroke-width="0.8125" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><filter id="filter0_b_1_36281" x="-60" y="-60" width="133" height="133" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feGaussianBlur in="BackgroundImageFix" stdDeviation="30"></feGaussianBlur><feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_36281"></feComposite><feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_36281" result="shape"></feBlend></filter></defs></svg>
                       <span>Added to cart</span>
                      </span>
                      <span class="p-add-cart-btn">Add to bag</span>
                   </button>
                </div>
           </div>
              
           </div>
        </div>
     </div>
   {{/products}}
</div>`;
var variantModalMarkUp = `
  <div class="wishlist-sizedrawer" id="modal">
    <div class="modal-guts">
      {{#product.options}}
        <div class="select-variant-{{name}} grid-size-variants " id="user-options-{{name}}">
          {{#values}}
            <div class="sywm-radio" data-value="{{.}}" var-id="">
              <input type="radio" name="{{name}}_{{ product.id  }}" data-value="{{.}}" id="user-option{{.}}_{{ product.id  }}">
              <label class="{{.}}" for="user-option{{.}}_{{product.id}}">{{.}}<span class="favourite-dots"></span></label>
            </div>
          {{/values}}
        </div>
      {{/product.options}}
    </div>
  </div>`;

function getVariantInfo(variants) {
  try {
    let variantKeys =
        variants && variants != "[]"
          ? Object.keys(JSON.parse(variants)[0])
          : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function popupclick(swat) {
  if (swat.target.classList.contains('custom-btn')) {
    const productItem = swat.target.closest('.product-item .snippet-product-grid');

    if (productItem) {
        const currentID = productItem.getAttribute('data-product-id');
       const currentVID = productItem.getAttribute('data-variant-id');
      const currentDURL = productItem.getAttribute('data-url');
      
        window._swat.fetch(function (products) {
            document.body.classList.add("active-wishli-pro");
            products.forEach(function (p) {
                const productId = p.empi; 
                
                if (productId.toString() === currentID) { 
                    const params = {
                        du: p.du,
                        empi: parseInt(productId),
                        epi: parseInt(p.epi),
                    };
                    window._swat.getProductDetails(params, function (productJson1) {
                        document.querySelectorAll('.wpp-buy-popup').forEach((variantAdd) => {
                        variantAdd.setAttribute('data-pro-id',productJson1.id);
                      });
                      document.querySelector('.wpp-head h3 a').textContent = productJson1.title;
                      document.querySelector('.wpp-head h3 a').setAttribute('href',productJson1.url);
                      document.querySelector('.pdb-link a').setAttribute('href',productJson1.url);
                      document.querySelector('.grid-price-wrap .original-price').textContent = productItem.querySelector('.original-price').textContent;
                      if (productJson1.compare_at_price != null) {
                        document.querySelector('.grid-price-wrap .compare-price').textContent = productItem.querySelector('.compare-price').textContent;
                      }else{
                        document.querySelector('.grid-price-wrap .compare-price').textContent = '';
                      }
                      document.querySelector('.wpp-media .first-img-wp').setAttribute('src',productJson1.images[0]);
                      document.querySelector('.wpp-media .sec-img-wp').setAttribute('src',productJson1.images[1]);

                      document.querySelectorAll('.wpp-head h3 a').forEach(function(titleElement) {
                        let title = titleElement.textContent;
                        let firstPart = title.split('|')[0].trim();
                        titleElement.textContent = firstPart;
                    });

                     const container = document.querySelector('.wpp-meta');
                      const ul = document.createElement('ul');
                      ul.classList.add('wpp-meta-ul');
                      productJson1.variants.forEach(variant => {
                        const li = document.createElement('li');
                        const a = document.createElement('a');
                        li.setAttribute("data-variant", variant.id);
                        a.textContent = variant.option2;
                        li.appendChild(a);
                        ul.appendChild(li);
                       
                      });
                      container.appendChild(ul);


                      if (productJson1.available == false) {
                          document.querySelector('.wpp-add-to-cart button').textContent = "Sold out";
                      }else{
                        document.querySelector('.wpp-add-to-cart button').textContent = "Add to bag";
                      }
                       document.querySelector('.wpp-media-wrap .swym-delete-btn').setAttribute('data-variant-id',currentVID);
                      document.querySelector('.wpp-media-wrap .swym-delete-btn').setAttribute('data-product-id',currentID);
                      document.querySelector('.wpp-add-to-cart .swym-add-to-cart-btn').setAttribute('data-product-id',currentID);
                      document.querySelector('.wpp-add-to-cart .swym-add-to-cart-btn').setAttribute('data-variant-id',currentVID);
                      document.querySelector('.wpp-add-to-cart .swym-add-to-cart-btn').setAttribute('data-url',currentDURL);

                      var jsonvariantid = productJson1.variants;
                      jsonvariantid.forEach(function (variant) {
                          const liElement = document.querySelector(`.wpp-meta-ul li[data-variant="${variant.id}"]`);
                          if (liElement && variant.available === false) {
                              liElement.classList.add("soldout_variant");
                          }
                      });
                      
                    });
                }
            });
          setTimeout(function () {
            document.querySelector(".wpp-meta-ul").addEventListener("click", (e) => {
              if (e.target.tagName === "LI" || e.target.closest("li")) {
                const clickedLi = e.target.closest("li");
                // console.log(clickedLi,"match li");
                document.querySelectorAll(".wpp-meta-ul li").forEach((li) => {
                  li.classList.remove("active");
                });

                
                clickedLi.classList.add("active");
                addtocartpopup();
                const paranode1 = clickedLi.closest(".wpp-buy-popup");
                const productId = paranode1.getAttribute("data-pro-id");
                const variantId = clickedLi.getAttribute("data-variant");
                const du = paranode1.getAttribute("data-url");
          
                if (clickedLi.classList.contains("soldout_variant")) {
                  const addToCartButton = document.querySelector('.wpp-add-to-cart .swym-add-to-cart-btn');
                  addToCartButton.textContent = "Sold out";
                  addToCartButton.disabled = true;
                  addToCartButton.classList.add("sold-out");
                } else {
                  const addToCartButton = document.querySelector('.wpp-add-to-cart .swym-add-to-cart-btn');
                  addToCartButton.textContent = "Add to bag";
                  addToCartButton.disabled = false;
                  addToCartButton.classList.remove("sold-out");
                }
              }
            });
          }, 1000);
        });
    } else {
        console.log('No product-item found for this button');
    }
  }
}

function addtocartpopup() {
  const addToCartButton = document.querySelector('.wpp-add-to-cart .swym-add-to-cart-btn');
  if (addToCartButton.classList.contains("sold-out")) {
    console.log("Cannot add sold-out product to cart.");
    return;
  }

  const productId = document.querySelector('.wpp-media-wrap .swym-delete-btn').getAttribute('data-product-id');
  const variantId = document.querySelector('.wpp-meta-ul li.active').getAttribute('data-variant');
  const productUrl = document.querySelector('.product-item .snippet-product-grid').getAttribute('data-url');

  const cartData = {
    id: variantId,
    quantity: 1
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(cartData)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add product to cart');
      }
      return response.json();
    })
    .then(data => {
      // console.log("Product added to cart:", data);
      addToCartButton.setAttribute("data-state-cart", "swym-added");
      load_cart();
      setTimeout(function () {
        document.querySelector("body").classList.add("open-drawer");
      }, 500);
    })
    .catch(error => {
      console.error('Error:', error);
    });
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        document.body.classList.remove("active-wishli-pro");
        const addToCartButton = document.querySelector('.wpp-add-to-cart .swym-add-to-cart-btn');
        addToCartButton.textContent = "Add to bag";
        addToCartButton.disabled = false;
        
        const createdUlElements = document.querySelectorAll('.wpp-meta-ul');
        createdUlElements.forEach(ul => ul.remove());
        
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  });
}
async function fetchProductData(wishlist) {
  const productDataPromises = wishlist.map(async (listItem) => {
    try {
      const countryCode = window.FC_CURRENT_MARKET_COUNTRY || '';
      const countrySuffix = countryCode ? `?country=${countryCode}` : '';
      const response = await fetch(`${listItem.du.split('?')[0]}.js${countrySuffix}`);
      listItem.productData = await response.json();
      return listItem;
    } catch (error) {
      console.error("Error fetching product:", listItem.du, error);
      return listItem;
    }
  });
  return await Promise.all(productDataPromises);
}
function swymRenderWishlist(swat) {
  swat.fetch(async function (products) {
  try {
      const wishlistWithProductData = await fetchProductData(products);
      console.log("Wishlist with full product JSON:", wishlistWithProductData);

      // Filter out archived products (no productData means product is archived/deleted)
      products = wishlistWithProductData.filter(function(item) {
        return item.productData !== undefined;
      });

    } catch (err) {
      console.error("Product data fetch failed:", err);
    }
    document.querySelector(".wishlist-count").textContent = "(" + products.length + ")";
    document.querySelector(".wishlist-count").setAttribute('data-count',products.length);
    var wishlistContentsContainer = document.getElementById(
      "wishlist-items-container"
    );
    var formattedWishlistedProducts = products.map(function (p, n) {
      completeProductJson = {};
      var productId = p.empi;
      var variantId = p.epi;
      var variantTitle = p.vi;
      var du = p.du;
      var params = {
        du: du,
        empi: parseInt(productId),
        epi: parseInt(variantId),
      };

      // Get the market-aware variant from productData (fetched with ?country= param)
      var mktVariant = p.productData && p.productData.variants
        ? p.productData.variants.find(function(v) { return v.id == variantId; })
        : null;

      variantButtonAttributes = {};
      variantButtonAttributes = params;
      window._swat.getProductDetails(params, function (productJson) {
      completeProductJson = productJson;
       
        productJson.du = du;
        var variantMarkUpTemplate = SwymUtils.renderTemplateString(
          variantModalMarkUp,
          {
            product: productJson,
          }
        );
        document.querySelectorAll('.snippet-product-grid[data-product-id="' +productId +'"] .grid-size-wrapper').forEach((variantAdd) => {
          variantAdd.innerHTML = variantMarkUpTemplate;
        });
        if (n == products.length - 1) {
          attachModalEventListeners();
        }
        // Use market-aware prices from productData if available, otherwise fall back to SWYM's getProductDetails response
        let price = mktVariant ? mktVariant.price : productJson.price;
        let handle = productJson.handle;
        let compare_at_price = mktVariant ? mktVariant.compare_at_price : productJson.compare_at_price;

        // Update displayed original price text with market-aware value
        var originalPriceEl = document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price');
        if (originalPriceEl && mktVariant) {
          originalPriceEl.textContent = _swat.currency + (price / 100).toFixed(2).replace(/\.00$/, '');
        }

        document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').setAttribute('data-wpd-variant-price',price);
        document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').setAttribute('data-wpd-product-handle',handle);
        
        if (compare_at_price != null) {
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .compare-price').classList.remove("d-none");
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .compare-price span').textContent = compare_at_price / 100;
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').setAttribute('data-wpd-variant-compare-at-price',compare_at_price);
          if (compare_at_price > price) {
            document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .grid-meta-inr').classList.add("pro-sale");  
            document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id + '"] .sale_badge').style.display = "block";
            document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id + '"] .compare-price').style.display = "block";
            
            let saving = ((compare_at_price - price) * 100) / compare_at_price;
            function customRound(value) {
              let remainder = value % 5;
              if (remainder <= 2) {
                return value - remainder;
              } else {
                return value + (5 - remainder);
              }
            }
          }
        } else {
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').style.color = "#464545";
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .compare-price').classList.add("d-none");
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id + '"] .sale_badge').style.display = "none";
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id + '"] .compare-price').style.display = "none";
        }
      
        if (productJson.images[1]) {
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .second-image').setAttribute("src", productJson.images[1]);
        } else {
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .swym-wishlist-image').style.opacity = "1";
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .second-image').classList.add("d-none");
        }
        if (productJson.available == false) {
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] #swym-custom-add-toCartBtn').classList.add("grid-soldOut");
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .p-add-cart-btn').textContent = "Sold out";
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .grid-price').classList.add("soldout_pro");
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .grid-meta-inr').classList.add("sold_plus_sale");
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .pro-sold').style.display = "block";
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .pro-sold.d-lg-none').style.display = "block";
        }
        
        var jsonvariantid = productJson.variants;
        jsonvariantid.forEach(function(i, value) {
            const element = document.querySelector('.snippet-product-grid[data-variant-id="' + variantId + '"] .sywm-radio[data-value="' + i.option1 + '"]');
            if (i.available == false) {
                const nextLabel = element.nextElementSibling;
                element.classList.add("soldout_variant")
            }
            var allvarName = i.title;
            if (i.title == variantTitle) {
                element.checked = !0;
                const nextLabel = element.nextElementSibling;
                element.classList.add("active")
            }
        })

        let images = document.querySelectorAll(".product-images img:not(.second-image)");
        images.forEach((img) => {
          if(img.complete){
            img.classList.add("loaded");
          }else{
            img.addEventListener("load", () => img.classList.add("loaded"));
          }
        });

      });
      countWishlist();
      // Override SWYM's stale stored price with market-aware price before template rendering
      if (mktVariant) {
        p.pr = (mktVariant.price / 100).toFixed(2);
      }
      p = SwymUtils.formatProductPrice(p);
  
      p.pr = p.pr.split('.')[0];
      p.isInCart =
        _swat.platform.isInDeviceCart(p.epi) ||
        p.et == _swat.EventTypes.addToCart;
      if (p.vi) {
        p.variantinfo = p.vi ? getVariantInfo(p.vi) : "";
        if (p.vi.includes("/")) {
          p.vi = p.vi.split("/")[0];
        } else if (p.vi.includes(" ")) {
          p.vi = p.vi.split(" ")[0];
        }
      }
      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts,
    });
    
    if (wishlistContentsContainer) {
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      document.querySelectorAll(".swym-wishlist-image").forEach((firstImg) => {
        let srcVal = firstImg.getAttribute("src");
        if (srcVal.includes("_620x620")) {
          srcVal = srcVal.replaceAll("_620x620", "");
        } else if (srcVal.includes("620")) {
          srcVal = srcVal.replaceAll("620", "");
        }
        firstImg.setAttribute("src", srcVal);
      });
              
      attachClickListeners();
    } else {
      console.log("Container not found, Wishlist Page element not found");
    }
  });
}
function attachClickListeners() {
  
  document.querySelectorAll('.swym-wishlist-grid').forEach(function(parent) {
   parent.querySelectorAll('.cus-add-btn').forEach(function (child) {
    child.addEventListener("mouseenter", function (event) {
      parent.querySelectorAll('.grid-btm').forEach(function (item) {
        item.classList.remove('active-add');
      });
      const packet = child.closest(".grid-btm");
      if (packet) {
        packet.classList.add('active-add');
      }
  
      const productItem = event.target.closest('.product-item .snippet-product-grid');
      if (productItem) {
        const currentID = productItem.getAttribute('data-product-id');
        window._swat.fetch(function (products) {
          const matchedProduct = products.find(p => p.empi.toString() === currentID);
  
          if (matchedProduct) {
            const params = {
              du: matchedProduct.du,
              empi: parseInt(matchedProduct.empi, 10),
              epi: parseInt(matchedProduct.epi, 10),
            };
  
            window._swat.getProductDetails(params, function (productJson1) {
              if (productJson1.id.toString() === currentID) {
                const jsonVariantId = productJson1.variants;
                if (jsonVariantId && jsonVariantId.length > 0) {
                  jsonVariantId.forEach(function (variant) {
                    if (variant.option2) {
                      const sizeElements = productItem.querySelectorAll('#user-options-Size .sywm-radio');
                      sizeElements.forEach((ele) => {
                        
                        const sizeValue = ele.getAttribute('data-value');
                        if (variant.option2 === sizeValue) {
                          ele.setAttribute('var-id',variant.id);
                          if (!variant.available) {
                            ele.classList.add("soldout_variant");
                          } else {
                            ele.classList.remove("soldout_variant");
                          }
                        }
                      });
                    }
                    attachModalEventListeners();
                  });
                }
              } else {
                console.warn('No matching product found for ID:', currentID);
              }
            });
          }
        });
      }
    });
   });
  });
  document.querySelectorAll('.grid-title a').forEach(function(titleElement) {
      let title = titleElement.textContent;
      let firstPart = title.split('|')[0].trim();
      titleElement.textContent = firstPart;
  });
    
  document.querySelectorAll('.swym-wishlist-grid').forEach(function (parent) {
    parent.querySelectorAll('.custom-btn').forEach(function (child) {
      child.addEventListener("click", popupclick);
    });
  });

  // document.querySelector('.wpp-add-to-cart').addEventListener("click",addtocartpopup);
  
  document.querySelector('.mpp-close').addEventListener("click", function(e) {
    document.body.classList.remove("active-wishli-pro");
    const addToCartButton = document.querySelector('.wpp-add-to-cart .swym-add-to-cart-btn');
    addToCartButton.textContent = "Add to bag";
    addToCartButton.disabled = false;
    const createdUlElements = document.querySelectorAll('.wpp-meta-ul');
    createdUlElements.forEach(ul => ul.remove());  
  });

  var addToCartButtons = document.querySelectorAll(
    "#swym-custom-add-toCartBtn"
  );
  var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  // for (var i = 0; i < addToCartButtons.length; i++) {
  //   addToCartButtons[i].addEventListener("click", onAddToCartClick, false);
  // }
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener("click", onRemoveBtnClick, false);
  }
}

function countWishlist() {
  window._swat.fetch(function (r) {
    document.querySelector(".wishlist-count").textContent = "(" + r.length + ")";
    document.querySelector(".wishlist-count").setAttribute('data-count',r.length);
  });
}

// function attachModalEventListeners() {
//   document
//     .querySelectorAll(".product-item .sywm-radio")
//     .forEach((radioWrapper) => {
//       radioWrapper.addEventListener("change", function (e) {

//         const parentGrid = e.target.closest(".snippet-product-grid");
//         if (!parentGrid) {
//           console.warn("Parent grid not found for .sywm-radio");
//           return;
//         }

//         const radioInput = radioWrapper.querySelector("input[type='radio']");
//         if (!radioInput) {
//           console.warn("Radio input not found inside .sywm-radio");
//           return;
//         }

//         parentGrid.querySelectorAll(".sywm-radio.active").forEach((activeRadio) => activeRadio.classList.remove("active"));

//         if (radioInput.checked) {
//           radioWrapper.classList.add("active");
//         } else {
//           console.warn("Radio is checked but active class was not applied.");
//         }

//         const isSoldOut = radioWrapper.classList.contains("soldout_variant");
//         const addToCartBtn = parentGrid.querySelector("#swym-custom-add-toCartBtn");

//         if (isSoldOut) {
//           addToCartBtn.classList.add("grid-soldOut");
//           addToCartBtn.textContent = "Sold Out";
//           addToCartBtn.setAttribute("disabled", "true");
//           console.log("This variant is sold out.");
//         } else {
//           addToCartBtn.classList.remove("grid-soldOut");
//           addToCartBtn.textContent = "Add to bag";
//           addToCartBtn.removeAttribute("disabled");

//           const productId = parentGrid.getAttribute("data-product-id");
//           const variantId = radioWrapper.getAttribute("data-variant-id");
//           const du = parentGrid.getAttribute("data-url");

//           const params = {
//             du: du,
//             empi: parseInt(productId),
//             epi: parseInt(variantId),
//           };

//           window._swat.getProductDetails(params, function (productJson) {
//             addToCartBtn.onclick = function () {
//               if (!isSoldOut) {
//                 const activeRadioWrapper = parentGrid.querySelector(".sywm-radio.active");
//                 const variantId = activeRadioWrapper.getAttribute("var-id");
//                 const cartData = {
//                   id: variantId,
//                   quantity: 1,
//                 };

//                 fetch("/cart/add.js", {
//                   method: "POST",
//                   headers: {
//                     "Content-Type": "application/json",
//                   },
//                   body: JSON.stringify(cartData),
//                 })
//                   .then((response) => {
//                     if (!response.ok) {
//                       throw new Error("Failed to add product to cart");
//                     }
//                     return response.json();
//                   })
//                   .then((data) => {
//                     load_cart();
//                     setTimeout(function () {
//                       document.querySelector("body").classList.add("open-drawer");
//                     }, 500);
//                   })
//                   .catch((error) => {
//                     console.error("Error:", error);
//                   });
//               } else {
//                 console.log("Cannot Add to bag, the variant is sold out.");
//               }
//             };
//           });
//         }
//       });
//     });
// }
function attachModalEventListeners() {
  document
    .querySelectorAll(".product-item .sywm-radio")
    .forEach((radioWrapper) => {

      radioWrapper.addEventListener("click", function (e) {

        const parentGrid = radioWrapper.closest(".snippet-product-grid");
        if (!parentGrid) return;

        const radioInput = radioWrapper.querySelector("input[type='radio']");
        if (!radioInput) return;

        if (radioWrapper.classList.contains("active")) return;

        radioInput.checked = true;

        parentGrid
          .querySelectorAll(".sywm-radio.active")
          .forEach((el) => el.classList.remove("active"));

        radioWrapper.classList.add("active");

        const isSoldOut = radioWrapper.classList.contains("soldout_variant");
        const addToCartBtn = parentGrid.querySelector("#swym-custom-add-toCartBtn");

        if (isSoldOut) {
          addToCartBtn.classList.add("grid-soldOut");
          addToCartBtn.textContent = "Sold Out";
          addToCartBtn.setAttribute("disabled", true);
          return;
        }

        addToCartBtn.classList.remove("grid-soldOut");
        addToCartBtn.textContent = "Add to bag";
        addToCartBtn.removeAttribute("disabled");

        const variantId = radioWrapper.getAttribute("var-id");
        if (!variantId) return;

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
          }),
        })
          .then((res) => {
            if (!res.ok) throw new Error("Add to cart failed");
            return res.json();
          })
          .then(() => {
            load_cart();
            setTimeout(() => {
              document.body.classList.add("open-drawer");
            }, 500);
            radioWrapper.classList.remove("active");
            radioInput.checked = false;
            setTimeout(()=>{
              document.querySelectorAll(".grid-btm.active-add").forEach((el) => el.classList.remove("active-add"));
            },2000);
          })
          .catch((err) => console.error(err));
      });
    });
}

attachModalEventListeners();

function getSelectTagValues(selector) {
  var userSelection = {};
  if (typeof selector !== "undefined") {
    var optionValue = selector.getAttribute("data-value");
    if (optionValue != undefined) {
      var key = "option" + (0 + 2);
      var selectedValueObj = _defineProperty({}, key, optionValue.toString());
      if (SwymUtils) {
        SwymUtils.extendDefaults(userSelection, selectedValueObj);
      }
    }
    return userSelection;
  } else {
    console.log("Invalid Option Selector");
  }
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function findVariant(userSelectedOption, completeProductJson1) {
    var keys = Object.keys(userSelectedOption).filter(function (key) {
      return (
        userSelectedOption[key] !== null && userSelectedOption[key] !== undefined
      );
    });
  
  var match = completeProductJson1.variants.find(function (variant) {
    return keys.every(function (key, value) {
      return (
        variant[key] === userSelectedOption[key] &&
        variant[value] === userSelectedOption[value]
      );
    });
  });
  
  return match;
}
function removeProductFromWishlist(old_product_variant, callback) {
  window._swat.removeFromWishList(old_product_variant, function (r) {
    callback(r);
  });
}
function addProductToWishlist(new_product_variant) {
  window._swat.addToWishList(new_product_variant, function (r) {
    renderWishlistUI();
  });
}
function renderWishlistUI() {
  _swat.fetch(function (products) {
    WishlistedProducts = JSON.parse(JSON.stringify(products));
    for (let i = 0; i < WishlistedProducts.length; i++) {
      _swat.getProductDetails(
        {
          du: WishlistedProducts[i].du,
          epi: WishlistedProducts[i].epi,
          empi: WishlistedProducts[i].empi,
        },
        function (fullProductDetails) {
          for (let j = 0; j < fullProductDetails.variants.length; j++) {
            var sameid = fullProductDetails.variants[j].id;
            
            if (fullProductDetails.variants[j].id == WishlistedProducts[i].epi) {
              WishlistedProducts[i].available = fullProductDetails.variants[j].available;
            }
          }
        }
        
      );
    }

    setTimeout(function (e) {
      var h3height = 0;
    }, 2000);
    currentUserWishlist = [];
    var wishlistContentsContainer = document.getElementById(
      "wishlist-items-container"
    );
    currentUserWishlist = products;
    var completeProductJson = {};
    var formattedWishlistedProducts = WishlistedProducts.map(function (p, n) {
      var productId = p.empi;
      var variantId = p.epi;
      var variantTitle = p.vi;
      var du = p.du;
      var params = {
        du: du,
        empi: parseInt(productId),
        epi: parseInt(variantId),
      };
      variantButtonAttributes = {};
      variantButtonAttributes = params;
      window._swat.getProductDetails(params, function (productJson) {
        completeProductJson = productJson;
        productJson.du = du;
        var variantMarkUpTemplate = SwymUtils.renderTemplateString(
          variantModalMarkUp,
          {
            product: productJson,
          }
        );
        document.querySelectorAll('.snippet-product-grid[data-product-id="' +productId +'"] .grid-size-wrapper').forEach((variantAdd) => {
          variantAdd.innerHTML = variantMarkUpTemplate;
        });
        if (n == products.length - 1) {
          attachModalEventListeners();
        }
        if (productJson.available == false) {
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] #swym-custom-add-toCartBtn').classList.add("grid-soldOut");
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .p-add-cart-btn').textContent = "Sold out";
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .grid-badge span').textContent = "Sold out";
        }
        
      var jsonvariantid = productJson.variants;
      jsonvariantid.forEach(function(i, value) {
          const element = document.querySelector('.snippet-product-grid[data-variant-id="' + variantId + '"] .sywm-radio[data-value="' + i.option1 + '"]');
          if (i.available == false) {
              const nextLabel = element;
              element.classList.add("soldout_variant")
          }
          var allvarName = i.title;
          if (i.option1 == variantTitle) {
              element.checked = !0;
              const nextLabel = element;
              element.classList.add("active")
          }
      })
        
      });
      
      countWishlist();
      p = SwymUtils.formatProductPrice(p);
      p.pr = p.pr.split('.')[0];
      p.variantinfo = p.variants ? getVariantInfo(p.variants) : "";
      p.isInCart =
        _swat.platform.isInDeviceCart(p.epi) ||
        p.et == _swat.EventTypes.addToCart;
      if (p.vi) {
        if (p.vi.includes("/")) {
          p.vi = p.vi.split("/")[0];
        } else if (p.vi.includes(" ")) {
          p.vi = p.vi.split(" ")[0];
        }
      }
      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: WishlistedProducts,
    });
    wishlistContentsContainer.innerHTML = productCardsMarkup;
    attachClickListeners();
  });
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist);
function bindProductItemMouseleave(root = document) {
  root
    .querySelectorAll(".swym-wishlist-grid .product-item")
    .forEach((grid) => {
      if (grid.dataset.mouseleaveBound) return;

      grid.dataset.mouseleaveBound = "true";

      grid.addEventListener("mouseleave", function () {
        document
          .querySelectorAll(".grid-btm.active-add")
          .forEach((el) => el.classList.remove("active-add"));
      });
    });
}
function handleOneSizeText() {
  document.querySelectorAll('.sywm-radio').forEach((item) => {
    if (item.dataset.value === 'One size') {
      const label = item.querySelector('label');

      if (label && label.childNodes.length) {
        // ✅ Replace only text, keep span
        label.childNodes[0].nodeValue = 'Add to bag';
      }

      // Optional helper class
      item.classList.add('one-size');
    }
  });
}

// Observe entire document until wishlist grid appears
const rootObserver = new MutationObserver(() => {
  const wishlistGrid = document.querySelector(".swym-wishlist-grid");

  if (!wishlistGrid) return;

  // Bind for existing items
  bindProductItemMouseleave(wishlistGrid);

  // Observe product-item injections inside wishlist grid
  const gridObserver = new MutationObserver(() => {
    bindProductItemMouseleave(wishlistGrid);
    handleOneSizeText();
  });

  gridObserver.observe(wishlistGrid, {
    childList: true,
    subtree: true,
  });

  // Stop observing once grid is found
  rootObserver.disconnect();
});

// Start watching for Swym DOM injection
rootObserver.observe(document.body, {
  childList: true,
  subtree: true,
});
